import React, { Component } from "react"
import "react-responsive-carousel/lib/styles/carousel.min.css"
import { Carousel } from "react-responsive-carousel"
import { media, styled } from "./mediaCSS"
import { StaticQuery, graphql, Link } from "gatsby"
import Img from "gatsby-image"

const SlideItem = styled.div`
  .topImage {
  }
`

export default class SliderSC extends Component {
  render() {
    return (
      <StaticQuery
        query={graphql`
          query {
            slideBurger: file(relativePath: { eq: "slideBurger.jpg" }) {
              childImageSharp {
                fluid(maxWidth: 600) {
                  ...GatsbyImageSharpFluid
                }
              }
            }
            slideGroup: file(relativePath: { eq: "slideGroup.jpg" }) {
              childImageSharp {
                fluid(maxWidth: 600) {
                  ...GatsbyImageSharpFluid
                }
              }
            }

            slideMenu: file(relativePath: { eq: "slideMenu.jpg" }) {
              childImageSharp {
                fluid(maxWidth: 600) {
                  ...GatsbyImageSharpFluid
                }
              }
            }

            slideOutside: file(relativePath: { eq: "slideOutside.jpg" }) {
              childImageSharp {
                fluid(maxWidth: 600) {
                  ...GatsbyImageSharpFluid
                }
              }
            }

            slideOutside2: file(relativePath: { eq: "slideOutside2.jpg" }) {
              childImageSharp {
                fluid(maxWidth: 600) {
                  ...GatsbyImageSharpFluid
                }
              }
            }

            slideOutsideIn: file(relativePath: { eq: "slideOutsideIn.jpg" }) {
              childImageSharp {
                fluid(maxWidth: 600) {
                  ...GatsbyImageSharpFluid
                }
              }
            }
          }
        `}
        render={data => {
          return (
            <Carousel
              autoPlay
              infiniteLoop
              showThumbs={false}
              showStatus={false}
              showIndicators={false}
            >
              <SlideItem>
                <Img fluid={data.slideBurger.childImageSharp.fluid} />
              </SlideItem>
              <SlideItem>
                <Img fluid={data.slideGroup.childImageSharp.fluid} />
              </SlideItem>
              <SlideItem>
                <Img fluid={data.slideMenu.childImageSharp.fluid} />
              </SlideItem>
              <SlideItem>
                <Img fluid={data.slideOutside.childImageSharp.fluid} />
              </SlideItem>
              <SlideItem>
                <Img fluid={data.slideOutside2.childImageSharp.fluid} />
              </SlideItem>
              <SlideItem>
                <Img fluid={data.slideOutsideIn.childImageSharp.fluid} />
              </SlideItem>
            </Carousel>
          )
        }}
      />
    )
  }
}
